/**
 * The ability a quest teaches one hero (plan 04, D43). The server grant, the login back-fill and the
 * client reward list all read through here, so what a quest shows is what it teaches.
 */
import type { QuestDefinition } from '../content/generated/quests.gen';
import { isDevCalling } from '../classes/devCalling';

/**
 * The ability `quest` teaches `heroClass`, if any. The internal dev calling is never listed in quest
 * data, so it takes the quest's first authored reward — testers can earn any quest ability.
 */
export function questRewardAbilityId(
  quest: Pick<QuestDefinition, 'rewardAbilities'> | null | undefined,
  heroClass: string | null | undefined,
): string | undefined {
  const rewards = quest?.rewardAbilities;
  const own = rewards?.[(heroClass ?? '').toLowerCase()];
  if (own || !rewards || !isDevCalling(heroClass ?? undefined)) return own;
  return Object.values(rewards)[0];
}
